<div class="gw-flex gw-flex-col gw-gap-medium">
  <div
    *ngIf="partners.length === 0"
    class="gw-rounded-2xl gw-border gw-border-dashed gw-border-border-normal gw-p-large gw-text-center gw-text-sm gw-text-text-secondary"
  >
    {{ 'features.onboarding.partnersList.emptyState' | translate }}
  </div>

  <div
    *ngFor="let partner of partners; let i = index"
    class="gw-rounded-2xl gw-border gw-border-border-normal gw-bg-background-elevation-2 gw-p-medium"
  >
    <div
      class="gw-flex gw-flex-wrap gw-items-center gw-justify-between gw-gap-medium"
    >
      <div class="gw-flex gw-min-w-0 gw-items-center gw-gap-x-small">
        <gatewee-icon
          *ngIf="formGroup.controls[i]?.invalid"
          icon="@phi.warning-circle"
          iconStyle="negative"
          size="20px"
          class="gw-shrink-0"
        ></gatewee-icon>
        <gatewee-icon
          *ngIf="formGroup.controls[i]?.valid"
          icon="@phi.check-circle"
          iconStyle="positive"
          size="20px"
          class="gw-shrink-0"
        ></gatewee-icon>

        <div class="gw-flex gw-flex-col gw-gap-x-small">
          <span
            *ngIf="formGroup.controls[i]?.invalid"
            class="gw-text-sm gw-text-status-negative"
          >
            {{
              'features.onboarding.partnersList.status.incomplete' | translate
            }}
          </span>
          <span
            *ngIf="formGroup.controls[i]?.valid"
            class="gw-text-sm gw-font-semibold gw-text-status-positive"
          >
            {{ 'features.onboarding.partnersList.status.complete' | translate }}
          </span>
          <span class="gw-text-sm gw-font-semibold gw-text-text-primary">
            {{
              partner.name ||
                ('features.onboarding.partnersList.defaultName'
                  | translate : {index: i + 1})
            }}
          </span>
        </div>
      </div>

      <div class="gw-flex gw-flex-shrink-0 gw-items-center gw-gap-x-small">
        <gatewee-button
          variant="outline"
          size="s"
          [title]="'common.actions.edit' | translate"
          [iconName]="'@phi.pencil'"
          (clicked)="editPartner(i)"
        ></gatewee-button>
        <gatewee-button
          variant="outline"
          [title]="'common.actions.delete' | translate"
          size="s"
          [iconName]="'@phi.trash'"
          (clicked)="deletePartner(i)"
        ></gatewee-button>
      </div>
    </div>
  </div>

  <div>
    <gatewee-button
      variant="primary"
      [title]="'features.onboarding.partnersList.addPartner' | translate"
      [iconName]="'@phi.plus'"
      (clicked)="addPartner()"
    ></gatewee-button>
  </div>
</div>
